var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"mb-2",attrs:{"no-gutters":""}},[_c('CustomUnitAdder',{on:{"update":_vm.getData}})],1),_c('v-card',[_c('v-card-text',[_c('CustomUnitGrid',{on:{"update":_vm.getData}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }